module.exports = __webpack_public_path__ + "img/card-back.672fb797.png";